import React, { Fragment, useState, useMemo } from "react";
import { connect } from "react-redux";
import {
  downloadDeviceStatistics,
  downloadDeviceOffboardStatistics,
} from "../../action/statistics";
import Alert from "../layout/Alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import Box from "@mui/material/Box";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { selectMenuProps } from "../../utils/selectMenuProps";
import DataTable from "../Common/DataTable/DataTable";
import FormInput from "../Common/FormInputs/MuiTextField";
import IconButton from "../Common/Button/IconButton";
import { PageHeading } from "../Common/Typography/AppTypography";

const Statistics = ({
  stats,
  downloadDeviceStatistics,
  downloadDeviceOffboardStatistics,
  allowedDeviceCategories,
  wrapperClass,
  ...props
}) => {
  const [category, setCategory] = useState(allowedDeviceCategories?.[0] ?? "");

  const statisticsRows = useMemo(
    () => [{ id: 1, description: "Device Statistics" }],
    []
  );

  const columns = useMemo(
    () => [
      { key: "description", label: "Files description", minWidth: 180 },
      {
        key: "category",
        label: "Device Category",
        minWidth: 140,
        render: () => (
          <Box sx={{ display: "block", maxWidth: { xs: "100%", md: 280 }, width: "100%" }}>
            <FormInput
              type="select"
              name="searchBy"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              options={(allowedDeviceCategories || []).map((el) => ({ value: el, label: el }))}
              size="small"
              fullWidth
              MenuProps={selectMenuProps}
            />
          </Box>
        ),
      },
      {
        key: "download",
        label: "Download",
        minWidth: 120,
        render: () => (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", minHeight: 40 }}>
            <IconButton
              icon={<FileDownloadIcon />}
              tooltip="Download"
              onClick={() => downloadDeviceStatistics(category)}
              variant="primary"
            />
          </Box>
        ),
      },
    ],
    [category, allowedDeviceCategories, downloadDeviceStatistics]
  );

  return (
    <Fragment>
      <ResponsiveContentWrapper className={wrapperClass || ""}>
        <Alert />
        <Box sx={{ width: "100%", minWidth: 0 }}>
          <PageHeading sx={{ mb: 2 }}>Download Statistics</PageHeading>
          <DataTable
            columns={columns}
            data={statisticsRows}
            rowKey="id"
            minWidth={320}
            striped={false}
            hoverEffect={false}
            msgForDisplay="No statistics available"
            tableContainerSx={{ width: "100%" }}
          />
        </Box>
      </ResponsiveContentWrapper>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  stats: state.statistics,
  permissions: state.auth.permissions,
  allowedDeviceCategories:state.auth.allowedDeviceCategories,
});

export default connect(mapStateToProps, {
  downloadDeviceStatistics,
  downloadDeviceOffboardStatistics,
})(Statistics);
